/* src/app/shared/layout/site-footer/site-footer.component.scss */
.footer-bar {
  bottom: 0;
  background-color: #222222;
  padding-top: 5px;
  padding-bottom: 2px;
  display: flex;
  flex: 1;
  justify-content: center;
  border-top-style: solid;
  border-top-width: 5px;
  border-top-color: #82baff;
}
.footer-bar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  width: 100%;
  padding-left: 42px;
  padding-right: 42px;
}
@media (max-width: 2560px) {
  .footer-bar-content {
    padding-left: 42px;
    padding-right: 42px;
  }
}
@media (max-width: 1920px) {
  .footer-bar-content {
    padding-left: 38px;
    padding-right: 38px;
  }
}
@media (max-width: 1280px) {
  .footer-bar-content {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (max-width: 1024px) {
  .footer-bar-content {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.logo-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}
.logo-image {
  height: 28px;
  width: auto;
}
.logo-text {
  text-align: left;
  font-size: 10pt;
  color: #9c9c9c;
  max-width: 450px;
}
@media (max-width: 2560px) {
  .logo-text {
    font-size: 10pt;
    max-width: 420px;
  }
}
@media (max-width: 1920px) {
  .logo-text {
    font-size: 10pt;
    max-width: 400px;
  }
}
@media (max-width: 1280px) {
  .logo-text {
    font-size: 8pt;
    max-width: 400px;
  }
}
@media (max-width: 1024px) {
  .logo-text {
    font-size: 8pt;
    max-width: 400px;
  }
}
.icons-container {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.icon-link {
  color: #fff;
  text-decoration: none;
  font-size: 16pt;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.icon-link:hover {
  background-color: #1b638b;
}
.text-block-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 80px;
}
.text-block {
  display: flex;
  flex-direction: column;
}
.text-block-heading {
  color: #CEECFF;
  text-decoration: none;
  font-size: 12pt;
  font-family: "Marsh Serif", serif;
  padding-block-end: 10px;
}
@media (max-width: 2560px) {
  .text-block-heading {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  .text-block-heading {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .text-block-heading {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .text-block-heading {
    font-size: 8pt;
  }
}
.text-block-link {
  color: #9c9c9c;
  text-decoration: none;
  font-size: 10pt;
}
@media (max-width: 2560px) {
  .text-block-link {
    font-size: 10pt;
  }
}
@media (max-width: 1920px) {
  .text-block-link {
    font-size: 9pt;
  }
}
@media (max-width: 1280px) {
  .text-block-link {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .text-block-link {
    font-size: 8pt;
  }
}
.text-block-link:hover {
  color: #cacaca;
}
/*# sourceMappingURL=site-footer.component-CRZISSMI.css.map */
